import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=19d95d84&scoped=true&"
import script from "./RoleModal.vue?vue&type=script&lang=js&"
export * from "./RoleModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleModal.vue?vue&type=style&index=0&id=19d95d84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d95d84",
  null
  
)

export default component.exports